import React, { useEffect, useRef, useState } from "react";
import nodeVideo from "../../assets/videos/node.mp4";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoSlash } from "@fortawesome/free-solid-svg-icons";

const VideoChat = () => {
  const videoRef = useRef(null);
  const navigate = useNavigate();
  const [hasCamera, setHasCamera] = useState(true);

  useEffect(() => {
    // Get camera permission and stream with cross-browser support
    const getCamera = async () => {
      try {
        // First ensure any existing tracks are stopped
        if (videoRef.current && videoRef.current.srcObject) {
          const tracks = videoRef.current.srcObject.getTracks();
          tracks.forEach(track => track.stop());
        }

        // Cross-browser getUserMedia
        const getUserMedia = navigator.getUserMedia || 
                           navigator.webkitGetUserMedia ||
                           navigator.mozGetUserMedia ||
                           navigator.msGetUserMedia ||
                           navigator.mediaDevices.getUserMedia;

        // For modern browsers
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          const stream = await navigator.mediaDevices.getUserMedia({ 
            video: {
              width: { ideal: 1280 },
              height: { ideal: 720 },
              facingMode: "user"
            }
          });
          if (videoRef.current) {
            videoRef.current.srcObject = stream;
            setHasCamera(true);
          }
        }
        // Legacy browsers
        else if (getUserMedia) {
          getUserMedia.call(navigator, 
            { video: true },
            (stream) => {
              if (videoRef.current) {
                // Handle different browser implementations
                if ("srcObject" in videoRef.current) {
                  videoRef.current.srcObject = stream;
                } else {
                  // For older browsers
                  videoRef.current.src = window.URL.createObjectURL(stream);
                }
                setHasCamera(true);
              }
            },
            (err) => {
              console.error("Error accessing camera:", err);
              handleCameraError(err);
            }
          );
        } else {
          setHasCamera(false);
          alert("Your browser does not support camera access. Please try a modern browser like Chrome, Firefox, or Safari.");
        }

      } catch (err) {
        console.error("Error accessing camera:", err);
        handleCameraError(err);
      }
    };

    const handleCameraError = (err) => {
      setHasCamera(false);
      if (err.name === "NotReadableError" || err.message.includes("Camera")) {
        alert("Camera is being used by another application. Please close other apps using the camera and try again.");
      } else if (err.name === "NotAllowedError" || err.name === "PermissionDeniedError") {
        alert("Camera access was denied. Please allow camera access and try again.");
      } else if (err.name === "NotFoundError" || err.name === "DevicesNotFoundError") {
        alert("No camera detected. Please connect a camera and try again.");
      } else {
        alert("Error accessing camera. Please check camera permissions and try again.");
      }
    };

    getCamera();

    // Cleanup function to stop camera stream
    return () => {
      if (videoRef.current && videoRef.current.srcObject) {
        const tracks = videoRef.current.srcObject.getTracks();
        tracks.forEach(track => track.stop());
      }
    };
  }, []);

  const handleDisconnect = () => {
    // Stop camera stream
    if (videoRef.current && videoRef.current.srcObject) {
      const tracks = videoRef.current.srcObject.getTracks();
      tracks.forEach(track => track.stop());
    }
    // Navigate to home page
    navigate('/home');
  };

  return (
    <div className="d-flex vh-80">
      <div className="w-50 position-relative">
        {hasCamera ? (
          <video 
            ref={videoRef}
            autoPlay
            playsInline
            muted // Required for autoplay in some browsers
            className="w-100 h-85 object-fit-cover"
            style={{
              height: '85vh', 
              border: '3px solid #2a0d60',
              WebkitTransform: 'scaleX(-1)', // Mirror effect for selfie view
              transform: 'scaleX(-1)'
            }}
          />
        ) : (
          <div 
            className="w-100 h-85 bg-dark d-flex align-items-center justify-content-center"
            style={{
              height: '85vh',
              border: '3px solid #2a0d60',
              color: 'white'
            }}
          >
            <p>Camera not available</p>
          </div>
        )}
        <button
          id="f"
          onClick={handleDisconnect}
          className="position-absolute bottom-0 start-50 translate-middle-x mb-3"
          style={{
            backgroundColor: '#ff0000',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '5px',
            cursor: 'pointer'
          }}
        >
          <FontAwesomeIcon icon={faVideoSlash} className="me-2" />
          Disconnect
        </button>
      </div>
      <div className="w-50">
        <video
          src={nodeVideo}
          autoPlay
          controls
          playsInline // Better mobile support
          className="w-100 h-85 object-fit-cover"
          style={{height: '85vh'}}
        />
      </div>
    </div>
  );
};

export default VideoChat;
